var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDisplay)?_c('div',{staticClass:"banner"},[_c('img',{attrs:{"src":require('@/assets/images/banner-landing-image.png'),"alt":"banner"}}),(_vm.hasInput)?_c('SearchInput'):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }